import { render, staticRenderFns } from "./LineItem.vue?vue&type=template&id=5379ef95&"
import script from "./LineItem.vue?vue&type=script&lang=js&"
export * from "./LineItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports